import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useSummaryChartsDataContext } from './hooks/useSummaryChartsDataContext';

export const TotalServices = () => {
    const { chartData } = useSummaryChartsDataContext();

    return (
        <Donut
            title={'Total de Atendimento'}
            subtitles={chartData?.totalServices?.map((item) => item.description)}
            chartData={chartData?.totalServices || []}
            colors={defaultColors.slice(0, chartData?.totalServices?.length) || []}
            height={300}
        />
    );
};
